import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ProductSale } from '../../../interfaces/tickets/ProductSale';

@Component({
  selector: 'ng-tickets-card-selection',
  styleUrls: ['./card-selection.component.scss', '../../tickets/styles/ticket.scss'],
  template: `
    <section>
      <ng-tickets-payment-resume [productSale]="productSale"></ng-tickets-payment-resume>

      <div class="card-selection">
        <h2 class="title-section">Dados de pagamento</h2>

        <div class="card-events" *ngIf="!productSale.card">
          <span>Cartão de crédito</span>
          <button class="btn btn-link" (click)="nextStep.emit('card-list')">
            Adicionar
          </button>
        </div>
      </div>

      <div class="card-container" *ngIf="productSale?.card">
        <ng-tickets-card-item
            [selectable]="false"
            [card]="productSale?.card"
            (remove)="resetSelection()">
        </ng-tickets-card-item>

        <button class="btn btn-link" (click)="resetSelection(); nextStep.emit('card-list')">Trocar</button>
      </div>

      <div class="container-button">
        <button class="btn btn-pink" (click)="nextStep.emit('product-list')"><i class="fa fa-chevron-left"></i> Voltar</button>
        <button class="btn btn-pink" (click)="nextEvent()">
          {{ !productSale?.card?.id ? 'Cartão de crédito' : 'Dados de envio' }} <i class="fa fa-chevron-right"></i>
        </button>
      </div>
    </section>
  `
})
export class CardSelectionComponent {

  @Input() productSale: ProductSale;
  @Output() nextStep = new EventEmitter();

  nextEvent() {
    if (this.productSale.card && this.productSale.card.id) {
      this.nextStep.emit('send-data');
    } else {
      this.nextStep.emit('card-list');
    }
  }

  resetSelection() {
    this.productSale.card = null;
    this.productSale.billing_address = null;
  }

}
